import { render, staticRenderFns } from "./reporting-base.vue?vue&type=template&id=0e7573d4&"
import script from "./reporting-base.vue?vue&type=script&lang=ts&"
export * from "./reporting-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports